import * as React from 'react';
import * as PropTypes from 'prop-types';

import {ButtonIcon, IconClose24, Tile} from 'pac-ux-components';

import {I18n} from '@aws-amplify/core';

import {Box, Center, Grid} from '@mantine/core';


export const ApplicationsList = ({applications, deleteApplication}) => {
    return (
        <Box>
            {applications.map((application, index) => {
                const className = index === 0 ? 'active-profile' : '';

                return (
                    <Tile key={index} className={className}>
                        <Box py="sm">
                            <Grid>
                                <Grid.Col xs={12} sm={10}>
                                    <Box px="sm" mt="sm">
                                        {application.origin}
                                    </Box>
                                </Grid.Col>

                                <Grid.Col xs={12} sm={2}>
                                    <Center mt="xs">
                                        <ButtonIcon
                                            title={I18n.get('Clear')}
                                            icon={<IconClose24/>}
                                            onClick={() => {
                                                return deleteApplication(
                                                    application
                                                );
                                            }}
                                            size="default"
                                        />
                                    </Center>
                                </Grid.Col>
                            </Grid>
                        </Box>
                    </Tile>
                );
            })}
        </Box>
    );
};

ApplicationsList.propTypes = {
    applications: PropTypes.array,
    deleteApplication: PropTypes.func,
};
